<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            class="customers-dialog"
            [disabled]="!mapForm.form.valid"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' CUSTOMER'">

  <form #mapForm="ngForm" autocomplete="off">
    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <ac-input-container label="Prefix Group" class="prefix-groups-input" [required]="!data.selectedItem.tag">
      <ac-select [(acModel)]="data.selectedItem.attributeGroups"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [searchable]="false"
                 [bindValue]="'id'"
                 [bindLabel]="'name'"
                 [allowClear]="true"
                 [multiple]="true"
                 [items]="data.prefixGroups" (onOpen)="setPrefixGroupDirty()">
      </ac-select>
      <arm-mat-error [enable]="prefixGroupDirty && !data.selectedItem.tag && isAttrGroupEmpty()"
                     [message]="'Either prefix group or policy studio tag is '"
                     [bold]="'required'">
      </arm-mat-error>
    </ac-input-container>

    <mat-form-field class="fullWidth">
      <mat-label>Policy Studio Tag</mat-label>
      <input [required]="!data.selectedItem.attributeGroups || data.selectedItem.attributeGroups.length === 0"
             matInput [(ngModel)]="data.selectedItem.tag" (ngModelChange)="updateLogicalConjunctionNotice()" name="tag">
      <mat-error>
        Either prefix group or policy studio tag is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <div fxLayout fxLayoutGap="10px">
      <mat-form-field class="fullWidth">
        <mat-label>SIP Header</mat-label>
        <mat-select required [(ngModel)]="data.selectedItem.sipHeaderName" name="sipHeaderName">
          <mat-option *ngFor="let item of sipHeaderOptions" [value]="item.value">
            {{item.text}}
          </mat-option>
        </mat-select>
        <mat-error>
          SIP Header is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>SIP Header Value</mat-label>
        <input matInput required [(ngModel)]="data.selectedItem.sipHeaderValue" name="sipHeaderValue">
        <mat-error>
          SIP Header value is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field class="fullWidth">
      <mat-label>CAC Profile</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.cacProfileId" name="cacProfileId">
        <mat-option></mat-option>
        <mat-option *ngFor="let item of data.cacProfiles" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <div class="logical-conjunction-notice" [innerHTML]="logicalConjunctionNotice"></div>
</arm-dialog>
